module.exports = __webpack_public_path__ + "static/scale-model-of-beale-park-in-bakersfield-california-0fe5aa9049b7a405f0248f28403af4c4.png";